import { primitive } from '../../CodesThatsGottaGoSomewhereElse';
import { ObjectHost } from './ObjectHost';
import { Host, Id, Locals, Ticker, Type } from './ObjectSymbols';

const Dead: unique symbol = Symbol('Dead');

export abstract class AbstractObject {

    public [Host]: ObjectHost;
    public [Id]: string;
    public [Locals]: Map<string, primitive> | null = null;
    public [Ticker]: number = 0;
    public [Type]: string;

    public get id(): string {
        return this[Id];
    }

    public get globalId(): string {
        return this[Id];
    }

    public get type(): string {
        return this[Type];
    }

    public get alive(): boolean {
        return this[Host].exists(this.id);
    }

    public get ticker(): number {
        return this[Ticker];
    }

    // public attachBurden(burden: Burden): void {
    //     (this[Burdens] ?? (this[Burdens] = new Set())).add(burden);
    // }

    // public detatchBurden(burden: Burden): boolean {
    //     return (this[Burdens]) ? this[Burdens].delete(burden) : false;
    // }

    // eslint-disable-next-line max-len
    // public on<K extends keyof T>(type: EventType<K>, callback: EventCallback<T[K]>): EventSubscription<T> {
    //     return this[Emitter].on(type, callback);
    // }

    // public off<K extends keyof T>(type: EventType<K>, callback?: EventCallback<T[K]>): void {
    //     this[Emitter].off(type, callback);
    // }

    protected init(): void {
        // This is for subclasses...
    }

    protected finalize(): void {
        this[Dead] = true;
        this[Locals] = null;
    }
}
